__turbopack_context__.v({
  "select": "f0ibMW_select",
});
